import { generatePath, Navigate, useParams } from 'react-router-dom';
import ROUTE_URLS from '../../constants/routeUrls';

/**
 * Redirects /automation-studio-new URLs to canonical /automation-studio.
 */
export default function AutomationStudioNewRedirect() {
    const params = useParams();
    const projectId = params.project_id;
    const testCaseId = params.test_case_id;

    const to = testCaseId
        ? generatePath(ROUTE_URLS.AUTOMATION_STUDIO_TEST_CASE, {
              project_id: projectId,
              test_case_id: testCaseId,
          })
        : generatePath(ROUTE_URLS.AUTOMATION_STUDIO, {
              project_id: projectId,
          });

    return <Navigate to={to} replace />;
}
